// 04 — The brooder. The save exists by now: screen 03 wrote it, so this screen
// reads the real flock and the real weather rather than a draft.
//
// REFOCUS §5 puts the lamp in the player's hands in the first minute, and the
// verdict under each dial is the sim's own (`brooderTsiFor`), so the answer
// moves with the day instead of being a label someone wrote next to the button.
// There is no way back: the chicks are named and in the save, and screen 03
// behind this one would ask for both again.

import { t } from '../../i18n';
import { setBrooderLamp } from '../actions';
import { button, div, h } from '../dom';
import { selectBrooderView } from '../selectors';
import type { Screen, ScreenContext } from '../router';
import { firstWaterScreen } from './firstWater';

export function brooderSetupScreen(): Screen<HTMLElement> {
  return {
    id: 'brooderSetup',
    render: (ctx: ScreenContext<HTMLElement>) => {
      const { store } = ctx.services;
      const view = selectBrooderView(store.getState());
      let setting = view.options[0]?.setting ?? 0;

      const optionsHost = div({ class: 'cf-row-grid cf-grid-3' });
      const foot = div({ class: 'cf-screen__foot' });

      const repaint = (): void => {
        optionsHost.replaceChildren(
          ...view.options.map((option) =>
            button(
              {
                class: 'cf-choice',
                attrs: { 'aria-pressed': String(option.setting === setting) },
                on: {
                  click: () => {
                    setting = option.setting;
                    repaint();
                  },
                },
              },
              h('span', { class: 'cf-choice__title', text: t(option.labelKey) }),
              h('span', { class: 'cf-choice__sub', text: t(option.verdictKey) }),
            ),
          ),
        );
        foot.replaceChildren(
          button({
            class: 'cf-btn cf-btn--primary',
            text: t('onboard.brooder.confirm'),
            on: {
              click: () => {
                setBrooderLamp(store, setting);
                ctx.router.replace(firstWaterScreen());
              },
            },
          }),
        );
      };

      const screen = div(
        { class: 'cf-screen' },
        div(
          { class: 'cf-screen__head' },
          h('span', { class: 'cf-eyebrow', text: t('onboard.step', { n: '4', of: '5' }) }),
        ),
        h('h1', { class: 'cf-display cf-display--sm', text: t('onboard.brooder.title') }),
        h('p', { class: 'cf-sub', text: t('onboard.brooder.subtitle') }),
        optionsHost,
        h('p', { class: 'cf-legend', text: t('onboard.brooder.hint') }),
        foot,
      );
      repaint();
      screen.tabIndex = -1;
      return screen;
    },
  };
}
